import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import VueAxios from 'vue-axios';

// layouts
import Default from '@/layouts/default';
import Empty from '@/layouts/empty';

// css
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import '@fortawesome/fontawesome-free/css/all.css';
import '@/assets/css/main.css';
import 'fullcalendar/dist/fullcalendar.min.css';
import 'daterangepicker/daterangepicker.css';
import 'bs-stepper/dist/css/bs-stepper.min.css';

// config
import { apiPath } from '@/config';
import { EventBus } from '@/events/';
import Cookies from 'js-cookie';

const axiosInstance = axios.create({
    'baseURL': apiPath,
    'withCredentials': true
});

if (Cookies.get('t')) {
    axiosInstance.defaults.headers.common = { 'Authorization': `bearer ${Cookies.get('t')}` };
}

axiosInstance.interceptors.response.use(
    (response) => { return response; },
    (error) => {
        if (error ? error.response ? error.response.status ? error.response.status : false : false : false) {
            if (error.response.status === 401) {
                EventBus.$emit('notLogIn');
            }
        }

        return new Promise((resolve, reject) => {
            reject(error);
        });
    });

Vue.use(VueAxios, axiosInstance);

Vue.config.productionTip = false;

const veeValidateConfig = {
    'errorBagName': 'validationErrors'
};

Vue.use(VeeValidate, veeValidateConfig);

Vue.component('default', Default);
Vue.component('empty', Empty);

router.beforeEach((to, from, next) => {
    // $('.modal').modal('hide');
    // $('.modal-backdrop').remove();
    let companyName = store.state.operator.companyNameDisplay;
    document.title = (to.meta && to.meta.title) ? `${companyName} - ${to.meta.title}` : companyName;
    next();
});

new Vue({
    router,
    store,
    'render': h => h(App),
    'computed': {
        companyName () {
            return this.$store.state.operator.companyNameDisplay;
        }
    },
    mounted () {
        this.getSiteGeneralDetails();
        // this.checkLoginStatus();
    },
    'methods': {
        checkLoginStatus () {
            if ((!this.$route.meta || (this.$route.meta && !this.$route.meta.shouldNotRequireLogin))) {
                this.axios.get('account/GetLoginStatus').then(({ data }) => {
                    if (data.data) {
                        this.$store.commit('setUserDetails', data.data);
                        this.$store.commit('setAppStatus', false);
                    }
                }).catch(() => {
                // Remove token
                    Cookies.remove('t');
                    this.axios.defaults.headers.common = {};

                    this.$store.commit('setAppStatus', true);
                    this.axios.get('account/logout')
                        .finally(() => {
                            this.$store.commit('setAppStatus', true);
                            this.$store.commit('clearUserState');

                            let queryReturn = {};

                            queryReturn.from = window.location.href;
                            this.$router.push({
                                'name': 'login',
                                'query': queryReturn
                            });
                        });
                });
            }
        },
        getSiteGeneralDetails () {
            this.axios.get('public/GeneralDetails').then(({ data }) => {
                if (data.data) {
                    this.$store.commit('initializeOperatorSetting', data.data);
                }
            });
        }
    }
}).$mount('#app');
